import {
  AttendanceStatus,
  CertificateResultStatus,
  OpenClassSessionAttendance,
} from '../types/OpenClass';
export type AttendanceDraft = {
  attendanceStatus: AttendanceStatus;
  comment: string;
};

type AttendanceDraftRow = Pick<
  OpenClassSessionAttendance,
  'attendanceStatus' | 'comment' | 'registrationId'
>;

// Nobody attended a class they booked no day of, so an empty list is not full attendance.
export const attendedAllSessions = (
  attendances: { attendanceStatus: AttendanceStatus }[],
): boolean =>
  attendances.length > 0 &&
  attendances.every(({ attendanceStatus }) => attendanceStatus === 'present');

export const failedAnySession = (
  attendances: { result: CertificateResultStatus }[],
): boolean => attendances.some(({ result }) => result === 'failed');

export const buildAttendanceDrafts = (
  registrationIds: number[],
  attendanceRows: AttendanceDraftRow[],
) => {
  const rowsByRegistrationId = new Map(
    attendanceRows.map((row) => [row.registrationId, row]),
  );

  return Object.fromEntries(
    registrationIds.map((registrationId) => {
      const row = rowsByRegistrationId.get(registrationId);
      return [
        registrationId,
        {
          attendanceStatus: row?.attendanceStatus ?? 'not_recorded',
          comment: row?.comment ?? '',
        },
      ];
    }),
  ) as Record<number, AttendanceDraft>;
};
